// extracted by mini-css-extract-plugin
export default {"customTooltip":"CustomizedTooltip_customTooltip__CrLGK"};